import request from "@/utils/request";

/**
 * 购彩计划支持的彩种
 *
 * @description 购彩计划支持的彩种
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryBetplanLotterys(playload) {
  return request({
    url: "/api/lottery/plan/queryBetplanLotterys",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}
/**
 * 根据彩种获取可用购彩计划
 *
 * @description 根据彩种获取可用购彩计划(不加密)
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryBetplans(playload) {
  return request({
    url: "/api/lottery/plan/queryBetplans",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}
/**
 * 获取购彩计划列表数据
 *
 * @description 获取购彩计划列表数据
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryBetplanBodys(playload) {
  return request({
    url: "/api/lottery/plan/queryBetplanBodys",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}
